import '../../css/header.css';

function Header(){
    return(
        <div className="bg-image-header">
            <div className="header-image" id="top">
                <h2>WELCOME TO KP.HOUSE CONSTRUCTION WEBSITE</h2>
                <p>
                    Lorem ipsum odor amet, consectetuer adipiscing elit. Ac purus in massa egestas mollis varius;
                    dignissim elementum. Mollis tincidunt mattis hendrerit dolor eros enim, nisi ligula ornare.
                    Hendrerit parturient habitant pharetra rutrum gravida porttitor eros feugiat. Mollis elit
                    sodales taciti duis praesent id. Consequat urna vitae morbi nunc congue.
                </p>
            </div>
        </div>
    );
}

export default Header;